import React from 'react';
import { Row, Col, notification } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload';
import { InjectedIntl, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  IElement,
  AppState,
  changeSelection,
  updateElementProp,
  updateCreativity,
  Status,
} from '../../../../../redux/modules';
import {
  CustomImageVideoElementInput,
  ImageVideoElementContainer,
  CustomLabelImageVideoElement,
  FlexImageVideoElementContainer,
} from '../../styles';
import { Input, Upload } from '../../../../../components';
import { uploadFile, validateDimensions } from '../../../../../utils';
import { UploadFile } from 'antd/lib/upload/interface';

interface IProps {
  creativeId: string;
  index: number;
  element: IElement;
  updateElementProp?: any;
  updateCreativity?: any;
  changeSelection?: any;
  intl?: InjectedIntl;
  status: Status;
}

interface IState {
  isPosting?: boolean;
}

class VideoElementClass extends React.Component<IProps, IState> {
  state: IState = {};

  action = async (file: UploadFile) => {
    const { element, intl } = this.props;

    if (this.state.isPosting) {
      return;
    }

    if (!element.url) {
      return this.handleError(
        this.props.intl!.formatMessage({
          id: 'editor.error.uploadVideo.default',
        })
      );
    }

    if (file) {
      this.setState({ isPosting: true });
    }

    try {
      const newUrl = await uploadFile(file, true);
      const { error, data } = await validateDimensions(element.url, newUrl);

      if (error) {
        this.setState({ isPosting: false });
        return this.handleError(
          intl!.formatMessage(
            {
              id: `editor.error.uploadVideo.${error}`,
            },
            { ...data }
          )
        );
      }

      this.props.updateElementProp(this.props.creativeId, 'url', data.url);
      this.props.updateElementProp(this.props.creativeId, 'sources', false);
      this.props.updateCreativity(this.props.creativeId);

      this.handleSuccess(
        this.props.intl!.formatMessage({
          id: 'editor.uploadVideo.success',
        })
      );
    } catch (error) {
      this.handleError(
        this.props.intl!.formatMessage({
          id: 'editor.error.uploadVideo.default',
        })
      );
    }

    this.setState({ isPosting: false });
  };

  handleEnter = (index: number) => {
    this.props.changeSelection('element', index);
  };

  handleSuccess = (message: string) =>
    notification.open({
      message: this.props.intl!.formatMessage({ id: 'success' }),
      className: 'success',
      description: message,
      duration: 45,
    });

  handleError = (error: string) =>
    notification.open({
      message: this.props.intl!.formatMessage({ id: 'error' }),
      className: 'error',
      description: error,
      duration: 45,
    });

  render() {
    const {
      updateElementProp,
      creativeId,
      status,
      element,
      index,
    } = this.props;

    return (
      <ImageVideoElementContainer
        onClick={() => this.handleEnter(index)}
        key={`row_img_${index}`}
      >
        <CustomLabelImageVideoElement>
          {element.name}
        </CustomLabelImageVideoElement>
        <FlexImageVideoElementContainer>
          <CustomImageVideoElementInput
            value={element.url || ''}
            placeholder={'editor.info.placeholer.element.image'}
            onChange={event => {
              updateElementProp(creativeId, 'url', event.target.value);
              updateElementProp(creativeId, 'sources', false);
            }}
            disabled={
              element.locked ||
              status === Status.PUBLISHED ||
              status === Status.PENDING_VALIDATION
            }
          />
          <Upload
            action={this.action as any}
            isPosting={this.state.isPosting}
            disabled={
              element.locked ||
              status === Status.PUBLISHED ||
              status === Status.PENDING_VALIDATION
            }
            showUploadList={false}
          />
        </FlexImageVideoElementContainer>
      </ImageVideoElementContainer>
    );
  }
}

export const VideoElement = connect(
  (state: AppState, props: IProps) => ({}),
  {
    changeSelection,
    updateElementProp,
    updateCreativity,
  }
)(injectIntl(VideoElementClass as any));
